module.exports = __webpack_public_path__ + "static/media/totum_logo.ffdf8ee7.png";